export class PartnerConstants {

	public static readonly PARTNER = {
		PARTNER_IDENTIFIER: 'PARTNER@',
		EXT_IDENTIFIER: 'EXT@',
		UNAUTHORIZED_ERROR_KEY: 'UNAUTHORIZED_TOKEN_VERIFICATION',
		DUPLICATE_PORTFOLIO_NAME_ERROR: 'DUPLICATE_PORTFOLIO_NAME_ERROR'
	};

	public static readonly PARTNER_NAME = {
		ENVESTNET: 'envestnet',
		MERRILL_LYNCH: 'merrill_lynch_co'
	};

	public static readonly ACTIVATED_PARTNERS = [PartnerConstants.PARTNER_NAME.ENVESTNET];
	public static readonly MANAGED_MODELS_PARTNERS = [PartnerConstants.PARTNER_NAME.ENVESTNET];
	public static readonly SHOW_PARTNERS_VIEW = [PartnerConstants.PARTNER_NAME.ENVESTNET, PartnerConstants.PARTNER_NAME.MERRILL_LYNCH];

	public static readonly SSO_TOKEN_PATH = 'userAttributes.ssoInitiatedFrom';
	public static readonly EXT_SSO_TOKEN_PATH = 'userAttributes.extsso';

	public static readonly EXPORT_ACTIONS = {
		EDIT: 'editOriginal',
		CREATE: 'createNew'
	};
	public static readonly CUSTOM_IDENTIFIER_TYPE_SUFFIX = '_HANDLE';

	public static readonly ENVESTNET_SUPPORTED_PROGRAM_TYPE_IDS = [4, 6];

	public static readonly ENVESTNET_VALIDATION = {
		ALLOCATION_TARGET_OUT_OF_RANGE: 'allocation.target.out.of.range',
		ALLOCATION_TARGET_TOO_PRECISE: 'allocation.target.too.precise',
		MISSING_REQUIRED_HANDLE: 'missing.required.handle',
		MODEL_HANDLE_INVALID: 'model.handle.invalid',
		MODEL_NOT_DRAFT: 'model.not.draft',
		MODEL_NOT_FOUND: 'model.not.found',
		PROGRAM_HANDLE_INVALID: 'program.handle.invalid',
		PROGRAM_NOT_FOUND: 'program.not.found',
		REPEAT_SECURITY: 'repeat.security',
		RISKPOINT_HANDLE_INVALID: 'riskpoint.handle.invalid',
		RISKPOINT_NOT_FOUND: 'riskpoint.not.found',
		SECURITY_HANDLE_OR_CUSIP_REQUIRED: 'security.handle.or.cusip.required',
		SECURITY_REQUIRED: 'security.required',
		SECURITY_HANDLE_INVALID: 'security.handle.invalid',
		SECURITY_NOT_FOUND: 'security.not.found',
		CUSIP_NOT_FOUND: 'cusip.not.valid',
		SECURITY_NOT_ELIGIBLE: 'security.not.eligible',
		TOTAL_TARGET_NOT_HUNRED: 'total.target.not.hundred',
		MODEL_NOT_EDITABLE: 'model.not.editable'
	};

	public static readonly PARTNER_PORTFOLIO_FLAGS = {
		KEY: 'flags',
		SHOULD_REIMPORT: 'flags.originShouldReimport'
	};

	public static readonly PARTNER_REIMPORT_QUERY_PARAM = 'reimport';

	public static readonly PARTNER_SLEEVE_TYPES = ['SMA', 'MANAGED_MODEL', 'APM_SLEEVE'];

	public static readonly MAX_PARTNER_PORTFOLIOS_NEW_ANALYSIS = '1';
	public static readonly MODEL_CHANGED = 'MODEL_IS_MODIFIED_AT_SOURCE';
	public static readonly MODEL_REIMPORTED = 'MODEL_IS_OVERRIDDEN_AT_BLK';

	public static readonly PROGRAM_HANDLE_APM_PROGRAM_TYPE_ID = '4';

	public static readonly ORIGIN_PLATFORM_TYPE = {
		ASSET_CLASS: 'ASSET_CLASS'
	};

}
